import { render, staticRenderFns } from "./AdManCusNew.vue?vue&type=template&id=9587e28e&scoped=true"
import script from "./AdManCusNew.vue?vue&type=script&lang=js"
export * from "./AdManCusNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9587e28e",
  null
  
)

export default component.exports